import Carousel from 'embla-carousel';

const loadDropSpotFeaturesCarousel = () => {
  const carouselNode = document.querySelector('.drop-spot-features-carousel');
  const viewport = document.querySelector('.drop-spot-features-carousel--viewport');

  if (carouselNode && viewport) {
    const carousel = Carousel(viewport, {
      loop: false,
      draggableClass: 'cursor-grab',
      draggingClass: 'cursor-grabbing',
      align: 'start',
      containScroll: 'trimSnaps'
    });

    const onCarouselSelect = () => {
      const index = carousel.selectedScrollSnap();
      carousel.slideNodes().forEach((el, i) => el.classList.toggle('is-active', i === index));
    };

    const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
      prevBtn.addEventListener('click', embla.scrollPrev, false);
      nextBtn.addEventListener('click', embla.scrollNext, false);
    };

    const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
      return () => {
        if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');
        else prevBtn.setAttribute('disabled', 'disabled');

        if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');
        else nextBtn.setAttribute('disabled', 'disabled');
      };
    };

    const setupDotBtns = (dotsArray, embla) => {
      dotsArray.forEach((dotNode, i) => {
        dotNode.addEventListener('click', () => embla.scrollTo(i), false);
      });
    };

    const generateDotBtns = (dots, embla) => {
      const button = '<button type="button" class="drop-spot-features-carousel--dot"></button>';
      dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + button, '');
      return Array.from(dots.querySelectorAll('.drop-spot-features-carousel--dot'));
    };

    const selectDotBtn = (dotsArray, embla) => () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      dotsArray[previous].classList.remove('is-selected');
      dotsArray[selected].classList.add('is-selected');
    };

    const prevBtn = document.querySelector('[data-button="prev"]');
    const nextBtn = document.querySelector('[data-button="next"]');
    const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, carousel);

    const dots = document.querySelector('.drop-spot-features-carousel--dots');
    const dotsArray = generateDotBtns(dots, carousel);
    const setSelectedDotBtn = selectDotBtn(dotsArray, carousel);

    setupPrevNextBtns(prevBtn, nextBtn, carousel);
    if (dotsArray.length) setupDotBtns(dotsArray, carousel);

    onCarouselSelect();

    carousel.on('init', disablePrevAndNextBtns);
    carousel.on('select', onCarouselSelect);
    carousel.on('select', disablePrevAndNextBtns);
    if (dotsArray.length) {
      carousel.on('init', setSelectedDotBtn);
      carousel.on('select', setSelectedDotBtn);
    }
  }
};

export default loadDropSpotFeaturesCarousel;
